import {
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import {
  Observable,
  Subscription
} from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import { HaynesProLaborTimeModel }     from './typings/haynes-pro.labor-time';
import { HaynesProRepairSubjectModel } from './typings/haynes-pro.repair-subject';
import { HaynesProService }            from './haynes-pro.service';
import { VehicleModel }                from '../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-repair-times',
  template: require('./haynes-pro.repair-times.component.html')
})
export class HaynesProRepairTimesComponent implements OnDestroy, OnInit {
  private laborTimeRemovalSubscription : Subscription;
  private category                     : HaynesProLaborTimeModel;
  private subGroup                     : HaynesProLaborTimeModel;
  private subject                      : HaynesProRepairSubjectModel;

  public categories: Array<HaynesProLaborTimeModel> = [];
  public laborTimes: Array<HaynesProLaborTimeModel> = [];
  public subGroups : Array<HaynesProLaborTimeModel> = [];

  @BlockUI('haynesProRepairTimesBlock') block : NgBlockUI;

  @Input() removedLaborTime : Observable<HaynesProLaborTimeModel>;
  @Input() subjects         : Array<HaynesProRepairSubjectModel>;
  @Input() vehicle          : VehicleModel;
  @Input() viewMode         : boolean;

  @Output() onTimeAdd       : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();
  @Output() onTimeRemove    : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();

  constructor (
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService: HaynesProService,
    public translateService : TranslateService
  ) {}

  ngOnDestroy () : void {
    if (this.laborTimeRemovalSubscription) {
      this.laborTimeRemovalSubscription.unsubscribe();
    }
  }

  ngOnInit () : void {
    this.laborTimeRemovalSubscription = this.removedLaborTime.subscribe(( time : HaynesProLaborTimeModel ) => {
      this.haynesProService.removeLaborTime(this.laborTimes, time);
    });
  }

  handleCategorySelection ( category : HaynesProLaborTimeModel ) : void {
    this.block.start();

    this.category   = category;
    this.laborTimes = [];
    this.subGroup   = null;
    this.subGroups  = [];

    this.haynesProService.getRepairSubGroups(this.vehicle, this.subject, category)
    .then(( subGroups : Array<HaynesProLaborTimeModel> ) => {
      this.subGroups = subGroups;
    })
    .finally(() => {
      this.block.stop();
    });
  }

  handleSubgroupSelection ( subGroup : HaynesProLaborTimeModel ) : void {
    this.block.start();

    this.laborTimes = [];
    this.subGroup   = subGroup;

    this.haynesProService.getRepairSubGroups(this.vehicle, this.subject, subGroup)
    .then(( laborTimes : Array<HaynesProLaborTimeModel> ) => {
      this.laborTimes = this.haynesProService.removeTimesWithNoLabor(laborTimes);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  handleSubjectSelection ( subject : HaynesProRepairSubjectModel ) : void {
    this.block.start();

    this.categories = [];
    this.category   = null;
    this.laborTimes = [];
    this.subGroup   = null;
    this.subGroups  = [];
    this.subject    = subject;

    this.haynesProService.getRepairCategories(this.vehicle, subject)
    .then(( categories : Array<HaynesProLaborTimeModel> ) => {
      this.categories = categories;
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
